/**
 * Camada de Proteção de Conteúdo e Interface
 * - Desabilita menu de contexto (botão direito)
 * - Intercepta atalhos de inspeção (F12, Ctrl+Shift+I/J/C, Ctrl+U, Ctrl+S)
 * - Previne arraste de imagens e logos
 * - Emite aviso formal de propriedade intelectual no console
 */
export function initProtection() {
  if (typeof window === 'undefined') return;

  // Evita múltiplas inicializações no ciclo de vida do Astro ViewTransitions
  if ((window as any).__protectionInitialized) return;
  (window as any).__protectionInitialized = true;

  // 1. Bloqueia Menu de Contexto (Botão Direito)
  document.addEventListener(
    'contextmenu',
    (e: MouseEvent) => {
      e.preventDefault();
      return false;
    },
    { passive: false }
  );

  // 2. Bloqueia Teclas de Atalho de Inspeção e Extração de Código
  document.addEventListener(
    'keydown',
    (e: KeyboardEvent) => {
      const isMac = /(Mac|iPhone|iPod|iPad)/i.test(navigator.userAgent || '');
      const cmdOrCtrl = isMac ? e.metaKey : e.ctrlKey;

      // F12 (DevTools)
      if (e.key === 'F12') {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      // Ctrl + Shift + I / J / C (DevTools & Console & Inspect)
      if (cmdOrCtrl && e.shiftKey && ['I', 'J', 'C', 'i', 'j', 'c'].includes(e.key)) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      // Ctrl + U (View Source)
      if (cmdOrCtrl && (e.key === 'u' || e.key === 'U')) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      // Ctrl + S (Save Page)
      if (cmdOrCtrl && (e.key === 's' || e.key === 'S')) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    },
    { capture: true }
  );

  // 3. Previne arraste não autorizado de imagens e elementos gráficos
  document.addEventListener(
    'dragstart',
    (e: DragEvent) => {
      const target = e.target as HTMLElement | null;
      if (target && (target.tagName === 'IMG' || target.tagName === 'SVG' || target.closest('img'))) {
        e.preventDefault();
        return false;
      }
    },
    { passive: false }
  );

  // 4. Aviso de Propriedade Intelectual no Console
  try {
    console.log(
      '%c✦ JHONS RODRIGUES — SOFTWARE PROPRIETÁRIO ✦\n%cTodos os direitos reservados. O código-fonte, arquitetura, design e conteúdos desta aplicação são de propriedade intelectual exclusiva de Jhons Rodrigues (Lei nº 9.610/1998 e Lei nº 9.609/1998). Cópia, reprodução, distribuição ou engenharia reversa não autorizadas são estritamente proibidas.',
      'color: #F97316; font-size: 14px; font-weight: bold; padding: 4px 0;',
      'color: #9CA3AF; font-size: 12px; line-height: 1.5;'
    );
  } catch {}
}
